import { FC } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { pageAnimation } from '@const/animation';
import { motion } from 'framer-motion';
import Typography from '@components/common/typography';
import { QRCodeSVG } from 'qrcode.react';
import { TSetupTwoFAResult } from '@xeppt/xeppt-sdk/types';
import { Icon } from '@components/icons';
import { copyStringToClipboard } from '@utils/index';
import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
    onPrev: () => void;
    data?: TSetupTwoFAResult;
}

const Connect: FC<IProps> = ({ onSubmit, onPrev, data }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.main_wrapper}>
            <motion.div {...pageAnimation} className={styles.wrapper}>
                <div className={styles.text_wrapper}>
                    <Typography weight="semibold" variant="body1" className={styles.title}>
                        Connect authenticator app with your XEPPT account
                    </Typography>
                    <Typography variant="body2" className={styles.description}>
                        Open your authenticator app and connect it by scanning the QR code or
                        entering the setup key
                    </Typography>
                </div>
                {data && <QRCodeSVG value={data.url} level="H" size={200} includeMargin />}
                <div className={styles.other_divider}>
                    <Typography variant="body4" alignment="center">
                        or
                    </Typography>
                </div>
                <div className={styles.token_wrapper}>
                    <Typography variant="body1">{data?.token}</Typography>
                    <button onClick={() => copyStringToClipboard(data?.token || '')}>
                        <Icon name="copy" />
                    </button>
                </div>
                <div className={styles.actions}>
                    <Button leftIcon="arrow_left" variant="outlined-primary" onClick={onPrev}>
                        {submitLocale('previous')}
                    </Button>
                    <Button rightIcon="arrow_right" variant="primary" onClick={onSubmit}>
                        {submitLocale('next')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default Connect;
